import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

export const postsSlice = createSlice({
  name: 'posts',
  initialState: {
    isLoading: true,
    isDisplayLastPost: false,
    list: [],
    tiersList: [],
  },
  reducers: {
    postsStore: (state, { payload }) => {
      state.list = payload.list;
      state.tiersList = payload.tiersList || [];
      state.isDisplayLastPost = payload.isDisplayPreviewPosts;
      state.isLoading = false;
    },
    postsUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    postsUpdateIsDisplayLastPost: (state, action) => {
      state.isDisplayLastPost = action.payload;
    },
    postsUpdateList: (state, action) => {
      state.list = action.payload;
    },
    postsUpdateTiersList: (state, action) => {
      state.tiersList = action.payload;
    },
  },
});

export const { postsStore, postsUpdateList, postsUpdateIsLoading, postsUpdateIsDisplayLastPost, postsUpdateTiersList } = postsSlice.actions;

export const selectPostsList = (state) => state.posts.list;
export const selectPostsTiersList = (state) => state.posts.tiersList;

export const selectPostsSortedTiersItems = createSelector([selectPostsTiersList], (items) => {
  return sortItems(items);
});

export const selectPostsIsLoading = (state) => state.posts.isLoading;
export const selectPostsIsDisplayLastPost = (state) => state.posts.isDisplayLastPost;

export default postsSlice.reducer;
